var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.componentInput, {
    tag: "component",
    attrs: {
      $v: _vm.$v,
      data: _vm.data,
      values: _vm.values,
      "value-type": _vm.valueType,
      "input-type": _vm.inputType,
      "condition-name": _vm.conditionName,
      index: _vm.index,
    },
    on: { change: _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }